import type { TextStyle, ViewStyle } from 'react-native'

import { colors } from '../../../theme'
import { body4, headline3 } from '../../../theme/typography'

export const STATISTICS_CONTENT_PADDING_X = 18
export const STATISTICS_CONTENT_PADDING_BOTTOM = 16

const STAT_CARD_CONTENT_PADDING_X = 16
const STAT_CARD_CONTENT_PADDING_Y = 12
const STAT_CARD_BACKGROUND_COLOR = colors.backgroundSecondary

export const TITLE_TEXT_STYLE: TextStyle = {
  ...body4,
  color: colors.textBody,
}

export const VALUE_TEXT_STYLE: TextStyle = {
  ...headline3,
  color: colors.textHeader,
}

export const TIMEFRAME_TEXT_STYLE: TextStyle = {
  ...body4,
  color: colors.textBody,
}

export const STAT_CARD_STYLE: ViewStyle = {
  width: '48.4%',
  borderRadius: 8,
  paddingHorizontal: STAT_CARD_CONTENT_PADDING_X,
  paddingVertical: STAT_CARD_CONTENT_PADDING_Y,
  backgroundColor: STAT_CARD_BACKGROUND_COLOR,
  marginBottom: 14,
}

export const EXERCISE_GOAL_CARD_STYLE: ViewStyle = {
  borderRadius: 8,
  paddingHorizontal: STAT_CARD_CONTENT_PADDING_X,
  paddingVertical: STAT_CARD_CONTENT_PADDING_Y,
  backgroundColor: STAT_CARD_BACKGROUND_COLOR,
}

/** Voice assessment / Figma: 8px radius; history list rows use fill only (no stroke). */
const VOICE_ASSESSMENT_FIGMA_BORDER_RADIUS = 8
const VOICE_ASSESSMENT_FIGMA_PADDING_VERTICAL = 12
const VOICE_ASSESSMENT_FIGMA_PADDING_HORIZONTAL = 16
/** History accordion rows: taller tap target / visual weight than bordered banners */
const VOICE_ASSESSMENT_HISTORY_ROW_PADDING_VERTICAL = 16
export const VOICE_ASSESSMENT_FIGMA_GAP = 12

/** iOS-safe line height for analyzing-card headings; Cairo clips at its 16px font size. */
export const VOICE_ASSESSMENT_ANALYZING_TITLE_LINE_HEIGHT = 20

/** Inner padding only (shared by bordered cards and analyzing gradient frame). */
export const VOICE_ASSESSMENT_CARD_INNER_PADDING_STYLE: ViewStyle = {
  paddingTop: VOICE_ASSESSMENT_FIGMA_PADDING_VERTICAL,
  paddingRight: VOICE_ASSESSMENT_FIGMA_PADDING_HORIZONTAL,
  paddingBottom: VOICE_ASSESSMENT_FIGMA_PADDING_VERTICAL,
  paddingLeft: VOICE_ASSESSMENT_FIGMA_PADDING_HORIZONTAL,
}

/** History list accordion: no border; 16px vertical padding; gap before expanded body */
export const VOICE_ASSESSMENT_CARD_OUTER_STYLE: ViewStyle = {
  borderRadius: VOICE_ASSESSMENT_FIGMA_BORDER_RADIUS,
  paddingTop: VOICE_ASSESSMENT_HISTORY_ROW_PADDING_VERTICAL,
  paddingRight: VOICE_ASSESSMENT_FIGMA_PADDING_HORIZONTAL,
  paddingBottom: VOICE_ASSESSMENT_HISTORY_ROW_PADDING_VERTICAL,
  paddingLeft: VOICE_ASSESSMENT_FIGMA_PADDING_HORIZONTAL,
  gap: VOICE_ASSESSMENT_FIGMA_GAP,
}
